import React, { FunctionComponent, useState } from 'react';

import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ResponseFailedReason } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

interface Props {
    show: boolean;
    onClose: () => void;
    onSubmit: (reason: ResponseFailedReason, explanation?: string) => void;
}

export const ResponseFailedReasonModal: FunctionComponent<Props> = ({ show, onClose, onSubmit }) => {
    const { t } = useTranslation('reviews2');
    const [selectedReason, setSelectedReason] = useState<ResponseFailedReason>();
    const [explanation, setExplanation] = useState<string>();

    return (
        <Modal className="r4e-report-forward-modal" show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('MODAL_TITLE_REASON_FAILED')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group>
                    <Form.Check
                        type="radio"
                        label={t('FAILED_REASON_CLIENT_REQUEST')}
                        checked={selectedReason === ResponseFailedReason.ClientRequest}
                        onChange={() => {
                            setSelectedReason(ResponseFailedReason.ClientRequest);
                        }}
                    />
                    <Form.Check
                        type="radio"
                        label={t('FAILED_REASON_CREDENTIALS_MISSING')}
                        checked={selectedReason === ResponseFailedReason.CredentialsMissing}
                        onChange={() => {
                            setSelectedReason(ResponseFailedReason.CredentialsMissing);
                        }}
                    />
                    <Form.Check
                        type="radio"
                        label={t('FAILED_REASON_CREDENTIALS_INVALID')}
                        checked={selectedReason === ResponseFailedReason.CredentialsInvalid}
                        onChange={() => {
                            setSelectedReason(ResponseFailedReason.CredentialsInvalid);
                        }}
                    />
                    <Form.Check
                        type="radio"
                        label={t('FAILED_REASON_REVIEW_MISSING')}
                        checked={selectedReason === ResponseFailedReason.ReviewDeleted}
                        onChange={() => {
                            setSelectedReason(ResponseFailedReason.ReviewDeleted);
                        }}
                    />
                    <Form.Check
                        type="radio"
                        label={t('FAILED_REASON_OTHER')}
                        checked={selectedReason === ResponseFailedReason.Other}
                        onChange={() => {
                            setSelectedReason(ResponseFailedReason.Other);
                        }}
                    />
                </Form.Group>
                <Form.Group>
                    {selectedReason === ResponseFailedReason.Other && (
                        <Form.Control
                            as="textarea"
                            maxLength={140}
                            placeholder={t('FAILED_REASON_EXPLANATION')}
                            disabled={selectedReason !== ResponseFailedReason.Other}
                            onChange={({ target }) => setExplanation(target.value)}
                        />
                    )}
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="link" onClick={onClose}>
                    {t('CANCEL')}
                </Button>
                <Button
                    variant="success"
                    disabled={!selectedReason || (selectedReason === ResponseFailedReason.Other && !explanation)}
                    onClick={() => onSubmit(selectedReason!, explanation)}
                >
                    {t('SUBMIT')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
